<ng-container *ngIf="data$ | async as data"> </ng-container>
<div
  class="overflow-auto w-full h-full"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="50"
  [scrollWindow]="false"
  (scrolled)="onScroll()"
  [cslOverlayLoader]="loading$">
  <table mat-table [dataSource]="dataSource" class="w-full price-list-product-table">
    <!-- Preview Column -->
    <ng-container matColumnDef="preview">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <div class="preview-wrapper h-full w-full flex flex-col justify-center">
          <img class="preview" src="{{ getProductImagePath(item.id) }}" />
        </div>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef i18n>Название</th>
      <td mat-cell *matCellDef="let item">{{ item.name }}</td>
    </ng-container>

    <!-- Price Column -->
    <ng-container matColumnDef="price">
      <th mat-header-cell *matHeaderCellDef i18n>Стоимость</th>
      <td mat-cell *matCellDef="let item">
        <span *ngIf="item.processingMode === 0">{{ item.price | formatNumber : 2 | formatCurrency }}</span>
      </td>
    </ng-container>

    <!-- Article Column -->
    <ng-container matColumnDef="article">
      <th mat-header-cell *matHeaderCellDef i18n>Артикул</th>
      <td mat-cell *matCellDef="let item">{{ item.article }}</td>
    </ng-container>

    <!-- Width Column -->
    <ng-container matColumnDef="width">
      <th mat-header-cell *matHeaderCellDef i18n>Ширина</th>
      <td mat-cell *matCellDef="let item">{{ item.widthRange }}</td>
    </ng-container>

    <!-- Height Column -->
    <ng-container matColumnDef="height">
      <th mat-header-cell *matHeaderCellDef i18n>Высота</th>
      <td mat-cell *matCellDef="let item">{{ item.heightRange }}</td>
    </ng-container>

    <!-- Length Column -->
    <ng-container matColumnDef="length">
      <th mat-header-cell *matHeaderCellDef i18n>Глубина</th>
      <td mat-cell *matCellDef="let item">{{ item.lengthRange }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selectProduct(row.id)"></tr>
  </table>
</div>
